
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkits/[[...path]]",
      function () {
        return require("private-next-pages/toolkits/[[...path]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkits/[[...path]]"])
      });
    }
  